import React from 'react'
import CSSModules from 'react-css-modules'
import { Flex, Box } from 'reflexbox'
import Navigation from 'react-toolbox/lib/navigation'
import Link from 'react-toolbox/lib/link'

import ResetButton from './ResetButton'
import FilterButton from './FilterButton'
import Divider from 'components/fulcrum/divider/Divider'
import Collapse from 'components/fulcrum/collapse/Collapse'

import theme from './FilterMenuHeader.scss'

const FilterMenuHeader = props => (
  <Flex class={theme.filterContainer} align='center'>
    <span class={theme.header}>Approval</span>
    <Box class={theme.alignBox}></Box>
    <FilterButton onClick={ props.toggle }/>
    <ResetButton onClick={ props.getApprovals }/>
  </Flex>
)
export default CSSModules(FilterMenuHeader, theme)
